var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3C3.44772 3 3 3.44772 3 4C3 4.55228 3.44772 5 4 5H4.36039C4.83707 5 5.24749 5.33646 5.34097 5.80389L6.69787 12.5883C6.97832 13.9906 8.20956 15 9.63961 15H16.9872C18.3296 15 19.5086 14.1082 19.874 12.8165L20.9025 9.18045C21.3538 7.58485 20.1551 6 18.4969 6H7.4198L7.30213 5.41165C7.02168 4.00938 5.79044 3 4.36039 3H4ZM8.65903 12.1961L7.8198 8H18.4969C18.8285 8 19.0683 8.31697 18.978 8.63609L17.9495 12.2722C17.8277 12.7027 17.4347 13 16.9872 13H9.63961C9.16293 13 8.75251 12.6635 8.65903 12.1961Z",
    fill: "#293042"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21C10.1046 21 11 20.1046 11 19C11 17.8954 10.1046 17 9 17C7.89543 17 7 17.8954 7 19C7 20.1046 7.89543 21 9 21Z",
    fill: "#293042"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21C18.1046 21 19 20.1046 19 19C19 17.8954 18.1046 17 17 17C15.8954 17 15 17.8954 15 19C15 20.1046 15.8954 21 17 21Z",
    fill: "#293042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.9e182ff09e0d6be606c76f2322e9824c.svg";
export { ForwardRef as ReactComponent };